import React from 'react';
import TaxServicesPackageGroup from './taxServices-package-group';

const organizationPackages = [
	{
		label: 'Investment income / business income (with or without financial statements)',
		price: 'Fee on a quotation basis',
		name: 'Discussion of Personal tax matters with a CERTIFIED TAX ADVISOR',
		features: [
			'Consultation tailored to organizational tax matters',
			'Tax registration and compliance guidance',
			'Advice on reporting obligations and filings',
			'Support based on the scope of work required',
		],
	},
];

export default function OrganizationPackages({ onRequest }) {
	return (
		<TaxServicesPackageGroup
			title="Companies / Charitable Institutions / NGOs & Other Organizations"
			packages={organizationPackages}
			onRequest={onRequest}
		/>
	);
}